import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio } from "vue"

const _hoisted_1 = { class: "super" }
const _hoisted_2 = { class: "table-management" }
const _hoisted_3 = { class: "group-table" }
const _hoisted_4 = {
  class: "sub-table",
  style: {"margin-right":"36px"}
}
const _hoisted_5 = { class: "sub-table-title" }
const _hoisted_6 = { class: "sub-table" }
const _hoisted_7 = { class: "sub-table-title" }
const _hoisted_8 = { class: "user-table" }
const _hoisted_9 = { class: "table-title" }
const _hoisted_10 = { class: "form-management" }
const _hoisted_11 = { class: "group-form" }
const _hoisted_12 = { class: "group-title" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { class: "sub-group-form" }
const _hoisted_15 = { class: "group-title" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  selected: "",
  disabled: "",
  hidden: ""
}, "Select Group", -1)
const _hoisted_17 = ["value"]
const _hoisted_18 = ["disabled"]
const _hoisted_19 = { class: "user-form" }
const _hoisted_20 = { class: "user-title" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { class: "user-form-btn" }
const _hoisted_24 = {
  for: "true",
  class: "user-form-btn-label"
}
const _hoisted_25 = {
  for: "false",
  class: "user-form-btn-label"
}
const _hoisted_26 = { key: 0 }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  selected: ""
}, "Select Group", -1)
const _hoisted_28 = ["value"]
const _hoisted_29 = { key: 1 }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  selected: ""
}, "Select User", -1)
const _hoisted_31 = ["value"]
const _hoisted_32 = { key: 2 }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  selected: "",
  disabled: "",
  hidden: ""
}, "Select Group", -1)
const _hoisted_34 = ["value"]
const _hoisted_35 = { key: 3 }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  selected: "",
  disabled: "",
  hidden: ""
}, "Select Manager", -1)
const _hoisted_37 = ["value"]
const _hoisted_38 = { key: 4 }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  selected: "",
  disabled: "",
  hidden: ""
}, " Select Permission ", -1)
const _hoisted_40 = ["value"]
const _hoisted_41 = { key: 5 }
const _hoisted_42 = { key: 6 }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  selected: "",
  disabled: "",
  hidden: ""
}, " Select Permission ", -1)
const _hoisted_44 = ["value"]
const _hoisted_45 = { key: 7 }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  selected: "",
  disabled: "",
  hidden: ""
}, "Select Manager", -1)
const _hoisted_47 = ["value"]
const _hoisted_48 = { key: 8 }
const _hoisted_49 = { key: 9 }
const _hoisted_50 = { key: 10 }
const _hoisted_51 = ["disabled"]
const _hoisted_52 = ["disabled"]

import { computed, onMounted, ref } from "vue";
import AdministratorTable from "@/components/AdministratorTable.vue";
import {
  groupListAxios,
  signUpAxios,
  userListAxios,
  groupInsertAxios,
  userDeleteAxios,
  groupDeleteAxios,
  subGroupInsertAxios,
  subGroupListAxios,
  subGroupDeleteAxios,
  userRefactorAxios,
} from "@/service/super.service";
import _ from "lodash";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const userFormSelect = ref(true);

const list = ref({
  permission: [
    { text: "User", value: "user" },
    { text: "Manager", value: "manager" },
    { text: "Admin", value: "admin" },
  ],
  group: [] as any[],
  manager: [] as any[],
  user: [] as any[],
});

const groupTable = computed(() => {
  const item = list.value.group.map((val: any, idx) => {
    return {
      no: idx + 1,
      group: val,
    };
  });
  return {
    header: [{ label: "No" }, { label: "Group" }],
    item: item,
  };
});

const subGroupTable = computed(() => {
  const item = list.value.manager.map((val: any, idx) => {
    return {
      no: idx + 1,
      group: val.group,
      manager: val.sub_group,
    };
  });
  return {
    header: [{ label: "No" }, { label: "Group" }, { label: "Manger" }],
    item: item,
  };
});

const userTable = computed(() => {
  const item = list.value.user.map((val: any, idx) => {
    return {
      no: idx + 1,
      group: val.group,
      sub_group: val.sub_group,
      username: val.username,
      permission: val.permission,
      email: val.email,
    };
  });
  return {
    header: [
      { label: "No" },
      { label: "Group" },
      { label: "Manager" },
      { label: "Name" },
      { label: "Permission" },
      { label: "Email" },
    ],
    item: item,
  };
});
const groupForm = ref({
  group: "",
  sub_group: "",
  selectGroup: "",
});

const signForm = ref({
  name: "",
  password: "",
  group: "",
  permission: "",
  email: "",
  manager: "",
});

const userRefactorForm = ref({
  userName: "",
  group: "",
  subGroup: "",
  permission: "",
  email: "",
});

const formClear = async () => {
  if (userFormSelect.value) {
    signForm.value.name = "";
    signForm.value.password = "";
    signForm.value.group = "";
    signForm.value.manager = "";
    signForm.value.permission = "";
    signForm.value.email = "";
  } else if (!userFormSelect.value) {
    userRefactorForm.value.userName = "";
    userRefactorForm.value.group = "";
    userRefactorForm.value.subGroup = "";
    userRefactorForm.value.permission = "";
    userRefactorForm.value.email = "";
  }
};

const userSignUp = async (
  name: string,
  password: string,
  group: string,
  manager: string,
  permission: string,
  email: string
) => {
  await signUpAxios(name, password, group, manager, permission, email);
  await formClear();
  list.value.user = await userListAxios();
};

const groupInsert = async (group: string) => {
  await groupInsertAxios(group);
  groupForm.value.group = "";
  list.value.group = await groupListAxios();
  list.value.manager = await subGroupListAxios();
};

const subGroupInsert = async (subGroup: string, group: string) => {
  await subGroupInsertAxios(subGroup, group);
  groupForm.value.sub_group = "";
  groupForm.value.selectGroup = "";
  list.value.manager = await subGroupListAxios();
};

const deleteItem = async (pick: any) => {
  if (pick[0].username) {
    await userDeleteAxios(pick[0].username);
    list.value.user = await userListAxios();
    return;
  } else if (pick[0].manager && pick[0].group) {
    await subGroupDeleteAxios(pick[0].manager);
    list.value.manager = await subGroupListAxios();
    list.value.user = await userListAxios();
    return;
  } else if (pick[0].group) {
    await groupDeleteAxios(pick[0].group);
    list.value.group = await groupListAxios();
    list.value.user = await userListAxios();
    list.value.manager = await subGroupListAxios();
    return;
  }
};

const changeGroup = async () => {
  if (userFormSelect.value) {
    list.value.manager = await subGroupListAxios(signForm.value.group);
  } else {
    if (userRefactorForm.value.group === "super") {
      list.value.manager = await subGroupListAxios();
    } else {
      list.value.manager = await subGroupListAxios(
        userRefactorForm.value.group
      );
    }
  }
};

const userSelect = async (user: string) => {
  if (user !== "") {
    const userInfo = _.find(list.value.user, (item) => item.username === user);
    userRefactorForm.value.group = userInfo.group;
    if (userRefactorForm.value.group === "super") {
      list.value.manager = await subGroupListAxios();
    } else {
      list.value.manager = await subGroupListAxios(
        userRefactorForm.value.group
      );
    }
    userRefactorForm.value.subGroup = userInfo.sub_group;
    userRefactorForm.value.permission = userInfo.permission;
    userRefactorForm.value.email = userInfo.email;
  }
};

const userEdit = async (
  name: string,
  group: string,
  manager: string,
  permission: string,
  email: string
) => {
  if (manager === "") {
    manager = "";
  }

  await userRefactorAxios(name, group, manager, permission, email);
  await formClear();
  list.value.user = await userListAxios();
};

onMounted(async () => {
  list.value.group = await groupListAxios();
  list.value.manager = await subGroupListAxios();
  list.value.user = await userListAxios();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("group_list")), 1)
          ]),
          _createVNode(AdministratorTable, {
            header: _unref(groupTable).header,
            item: _unref(groupTable).item,
            height: 60,
            onDeleteItem: deleteItem
          }, null, 8, ["header", "item"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("manager_list")), 1)
          ]),
          _createVNode(AdministratorTable, {
            header: _unref(subGroupTable).header,
            item: _unref(subGroupTable).item,
            height: 60,
            onDeleteItem: deleteItem
          }, null, 8, ["header", "item"])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("user_list")), 1)
        ]),
        _createVNode(AdministratorTable, {
          header: _unref(userTable).header,
          item: _unref(userTable).item,
          height: 60,
          onDeleteItem: deleteItem
        }, null, 8, ["header", "item"])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("form", {
          onSubmit: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (groupInsert(groupForm.value.group)), ["prevent"]))
        }, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("group_insert")), 1)
            ]),
            _withDirectives(_createElementVNode("input", {
              class: "group-create-input",
              type: "text",
              placeholder: "Group",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((groupForm.value.group) = $event))
            }, null, 512), [
              [_vModelText, groupForm.value.group]
            ])
          ]),
          _createElementVNode("button", {
            disabled: groupForm.value.group === '',
            class: "group-btn"
          }, _toDisplayString(_ctx.$t("group_create")), 9, _hoisted_13)
        ], 32)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("form", {
          onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (
            subGroupInsert(groupForm.value.sub_group, groupForm.value.selectGroup)
          ), ["prevent"]))
        }, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("manager_insert")), 1)
            ]),
            _createElementVNode("div", null, [
              _withDirectives(_createElementVNode("select", {
                style: {"margin-top":"8px"},
                class: "group-select",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((groupForm.value.selectGroup) = $event))
              }, [
                _hoisted_16,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value.group, (item, idx) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: idx,
                    value: item
                  }, _toDisplayString(item), 9, _hoisted_17))
                }), 128))
              ], 512), [
                [_vModelSelect, groupForm.value.selectGroup]
              ])
            ]),
            _withDirectives(_createElementVNode("input", {
              class: "group-create-input",
              type: "text",
              placeholder: "Manager",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((groupForm.value.sub_group) = $event))
            }, null, 512), [
              [_vModelText, groupForm.value.sub_group]
            ])
          ]),
          _createElementVNode("button", {
            disabled: 
              groupForm.value.sub_group === '' || groupForm.value.selectGroup === ''
            ,
            class: "group-btn"
          }, _toDisplayString(_ctx.$t("manager_create")), 9, _hoisted_18)
        ], 32)
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("form", {
          onSubmit: _cache[21] || (_cache[21] = _withModifiers(() => {}, ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_20, [
            (userFormSelect.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.$t("user_insert")), 1))
              : _createCommentVNode("", true),
            (!userFormSelect.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.$t("user_edit")), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_23, [
              _withDirectives(_createElementVNode("input", {
                onClick: formClear,
                class: "add-btn",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((userFormSelect).value = $event)),
                value: true,
                type: "radio",
                name: "userForm",
                id: "true"
              }, null, 512), [
                [_vModelRadio, userFormSelect.value]
              ]),
              _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t("add")), 1),
              _withDirectives(_createElementVNode("input", {
                onClick: formClear,
                class: "refactor-btn",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((userFormSelect).value = $event)),
                value: false,
                type: "radio",
                name: "userForm",
                id: "false"
              }, null, 512), [
                [_vModelRadio, userFormSelect.value]
              ]),
              _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.$t("edit")), 1)
            ])
          ]),
          (userFormSelect.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _withDirectives(_createElementVNode("select", {
                  onChange: changeGroup,
                  class: "group-select",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((signForm.value.group) = $event))
                }, [
                  _hoisted_27,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value.group, (item, idx) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: idx,
                      value: item
                    }, _toDisplayString(item), 9, _hoisted_28))
                  }), 128))
                ], 544), [
                  [_vModelSelect, signForm.value.group]
                ])
              ]))
            : _createCommentVNode("", true),
          (!userFormSelect.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                _withDirectives(_createElementVNode("select", {
                  onChange: _cache[8] || (_cache[8] = ($event: any) => (userSelect(userRefactorForm.value.userName))),
                  class: "group-select",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((userRefactorForm.value.userName) = $event))
                }, [
                  _hoisted_30,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value.user, (item, idx) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: idx,
                      value: item.username
                    }, _toDisplayString(item.username), 9, _hoisted_31))
                  }), 128))
                ], 544), [
                  [_vModelSelect, userRefactorForm.value.userName]
                ])
              ]))
            : _createCommentVNode("", true),
          (!userFormSelect.value && userRefactorForm.value.userName)
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                _withDirectives(_createElementVNode("select", {
                  onChange: changeGroup,
                  class: "permission-select",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((userRefactorForm.value.group) = $event))
                }, [
                  _hoisted_33,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value.group, (item, idx) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: idx,
                      value: item
                    }, _toDisplayString(item), 9, _hoisted_34))
                  }), 128))
                ], 544), [
                  [_vModelSelect, userRefactorForm.value.group]
                ])
              ]))
            : _createCommentVNode("", true),
          (
              !userFormSelect.value &&
              userRefactorForm.value.userName &&
              userRefactorForm.value.permission === 'manager'
            )
            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                _withDirectives(_createElementVNode("select", {
                  class: "permission-select",
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((userRefactorForm.value.subGroup) = $event))
                }, [
                  _hoisted_36,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value.manager, (item, idx) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: idx,
                      value: item.sub_group
                    }, _toDisplayString(item.sub_group), 9, _hoisted_37))
                  }), 128))
                ], 512), [
                  [_vModelSelect, userRefactorForm.value.subGroup]
                ])
              ]))
            : _createCommentVNode("", true),
          (!userFormSelect.value && userRefactorForm.value.userName)
            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                _withDirectives(_createElementVNode("select", {
                  class: "permission-select",
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((userRefactorForm.value.permission) = $event))
                }, [
                  _hoisted_39,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value.permission, (item, idx) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: idx,
                      value: item.value
                    }, _toDisplayString(item.text), 9, _hoisted_40))
                  }), 128))
                ], 512), [
                  [_vModelSelect, userRefactorForm.value.permission]
                ])
              ]))
            : _createCommentVNode("", true),
          (!userFormSelect.value && userRefactorForm.value.userName)
            ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                _withDirectives(_createElementVNode("input", {
                  class: "email-input",
                  type: "email",
                  placeholder: "Email",
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((userRefactorForm.value.email) = $event))
                }, null, 512), [
                  [_vModelText, userRefactorForm.value.email]
                ])
              ]))
            : _createCommentVNode("", true),
          (userFormSelect.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                _withDirectives(_createElementVNode("select", {
                  class: "permission-select",
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((signForm.value.permission) = $event))
                }, [
                  _hoisted_43,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value.permission, (item, idx) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: idx,
                      value: item.value
                    }, _toDisplayString(item.text), 9, _hoisted_44))
                  }), 128))
                ], 512), [
                  [_vModelSelect, signForm.value.permission]
                ])
              ]))
            : _createCommentVNode("", true),
          (signForm.value.permission === 'manager' && userFormSelect.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                _withDirectives(_createElementVNode("select", {
                  class: "group-select",
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((signForm.value.manager) = $event))
                }, [
                  _hoisted_46,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value.manager, (item, idx) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: idx,
                      value: item.sub_group
                    }, _toDisplayString(item.sub_group), 9, _hoisted_47))
                  }), 128))
                ], 512), [
                  [_vModelSelect, signForm.value.manager]
                ])
              ]))
            : _createCommentVNode("", true),
          (userFormSelect.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                _withDirectives(_createElementVNode("input", {
                  class: "name-input",
                  type: "text",
                  placeholder: "User Name",
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((signForm.value.name) = $event))
                }, null, 512), [
                  [_vModelText, signForm.value.name]
                ])
              ]))
            : _createCommentVNode("", true),
          (userFormSelect.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                _withDirectives(_createElementVNode("input", {
                  class: "pwd-input",
                  type: "password",
                  placeholder: "Password",
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((signForm.value.password) = $event))
                }, null, 512), [
                  [_vModelText, signForm.value.password]
                ])
              ]))
            : _createCommentVNode("", true),
          (userFormSelect.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                _withDirectives(_createElementVNode("input", {
                  class: "email-input",
                  type: "email",
                  placeholder: "Email",
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((signForm.value.email) = $event))
                }, null, 512), [
                  [_vModelText, signForm.value.email]
                ])
              ]))
            : _createCommentVNode("", true),
          (userFormSelect.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 11,
                onClick: _cache[19] || (_cache[19] = ($event: any) => (
              userSignUp(
                signForm.value.name,
                signForm.value.password,
                signForm.value.group,
                signForm.value.manager,
                signForm.value.permission,
                signForm.value.email
              )
            )),
                disabled: 
              signForm.value.group === '' ||
              signForm.value.permission === '' ||
              signForm.value.name === '' ||
              signForm.value.password === '' ||
              signForm.value.email === ''
            ,
                class: "user-btn"
              }, _toDisplayString(_ctx.$t("user_create")), 9, _hoisted_51))
            : _createCommentVNode("", true),
          (!userFormSelect.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 12,
                onClick: _cache[20] || (_cache[20] = ($event: any) => (
              userEdit(
                userRefactorForm.value.userName,
                userRefactorForm.value.group,
                userRefactorForm.value.subGroup,
                userRefactorForm.value.permission,
                userRefactorForm.value.email
              )
            )),
                disabled: 
              userRefactorForm.value.group === '' ||
              userRefactorForm.value.permission === '' ||
              userRefactorForm.value.userName === '' ||
              userRefactorForm.value.email === ''
            ,
                class: "user-btn"
              }, _toDisplayString(_ctx.$t("user_edit")), 9, _hoisted_52))
            : _createCommentVNode("", true)
        ], 32)
      ])
    ])
  ]))
}
}

})